/**
 * Create default messages for any plan type
 * @param {Array} processedJsonFiles - Processed JSON files
 * @param {string} input - User input text
 * @param {Array} uploadedImages - Uploaded images
 * @returns {Object} - Object containing data and user messages
 */
export const createDefaultMessages = (
  processedJsonFiles,
  input,
  uploadedImages
) => {
  const userMessage = {
    role: 'user',
    content: [
      {
        type: 'text',
        text:
          input ||
          'Attaching an image to analyze and maybe data to support. Describe the image in detail.',
      },
      ...(uploadedImages
        ? uploadedImages.map((m) => ({ type: 'image', image: m[0] }))
        : []),
    ],
  };

  return {
    dataMessages: [],
    userMessage,
  };
};
